module.exports = __webpack_public_path__ + "static/media/sports_About.9587dc78.jpg";